import './Loader.css';
import React from 'react';

export const Loader = ({ active }) => active ? (
  <div className='loader__wrapper'>
    <div className="loader"></div>
  </div>
) : null;
